


































import Vue from "vue";
export default Vue.extend({
  name: "SuccessCard",

  props: {
    title: {
      type: String,
      required: false,
      default: "Sukces!"
    },

    message: {
      type: String,
      required: false,
      default: ""
    }
  }
});
